import type { UseModalProps } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { useCreateContractMutation } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { FormMode } from "@src/utils/types";
import { omit } from "lodash";
import { observer } from "mobx-react-lite";
import React, { type FunctionComponent, useContext, useState } from "react";
import { DocumentsCtx } from "../../StoreDocuments";
import { useOptions } from "./Common";
import { ModalEditContractForm } from "./ModalEditContractForm";
import { StoreContractForm } from "./StoreContractForm";

export const ModalCreateContract: FunctionComponent<
  React.PropsWithChildren<UseModalProps>
> = observer(function ModalCreateContract(props) {
  const documentsStore = useContext(DocumentsCtx);
  const [store] = useState(() => {
    return StoreContractForm.create();
  });

  const onClose = () => {
    store.form.form.reset();
    props.onClose();
  };

  const [create, createReq] = useCreateContractMutation({
    onCompleted() {
      documentsStore.refetchContracts?.();
      onClose();
    },
    ...onError(),
  });

  useOptions(store, documentsStore);

  return (
    <React.Fragment>
      {props.isOpen && (
        <ModalEditContractForm
          {...props}
          title={t`Add new contract`}
          store={store}
          primaryActionContent={t`Save document`}
          loading={createReq.loading}
          onSubmit={(vars) => {
            create({
              variables: { input: { ...omit(vars, "valid_to_indefinite") } },
            });
          }}
          onClose={onClose}
          prefillFormFields={documentsStore.prefillFormFields}
          mode={FormMode.CREATE}
        />
      )}
    </React.Fragment>
  );
});
